var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.982,
    height: 45.748,
    viewBox: "0 0 222.982 45.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-92.769 -96.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(92.769 96.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M136.237,96.084h-18.7l-3.414,5.866h22.11a17.008,17.008,0,1,1,0,34.016H122.124V121.8h14.113a2.933,2.933,0,1,0,0-5.866H116.258v25.9h19.979a22.874,22.874,0,1,0,0-45.748Z",
    transform: "translate(-108.28 -96.084)",
    fill: "#f90000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M127.481,145.655a6.778,6.778,0,0,1-6.755,6.944h-10.1v5.866h10.1a12.444,12.444,0,0,0,8.991-3.78,13.045,13.045,0,0,0,0-18.06,12.445,12.445,0,0,0-8.991-3.779H96.173l-3.4,5.866h27.957A6.778,6.778,0,0,1,127.481,145.655Z",
    transform: "translate(-92.769 -122.781)",
    fill: "#f90000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(71.084 10.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M363.183,132.745H352.412v25.316h10.532c8.025,0,12.869-5.592,12.869-12.975C375.813,137.6,370.821,132.745,363.183,132.745Zm-.476,20.894h-4.625V137.167h4.658c5.136,0,7.217,3.8,7.217,7.932C369.957,150.029,367.735,153.639,362.707,153.639Z",
    transform: "translate(-352.412 -132.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M482.15,147.829c0,4.6-2.513,6.3-5.758,6.3-2.829,0-5.892-1.439-5.892-6.3V132.745h-5.679v14.917c0,8.455,5.576,10.757,11.495,10.757,5.783,0,11.508-2.206,11.508-10.862V132.745H482.15Z",
    transform: "translate(-434.046 -132.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 5.67,
    height: 25.316,
    transform: "translate(118.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M832.748,132.745v4.486h7.372v20.83h5.675v-20.83h7.347v-4.486Z",
    transform: "translate(-701.243 -132.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M674.96,132.745l-8.905,25.316h5.575l7.041-20.577,7.041,20.577h5.575l-8.905-25.316Z",
    transform: "translate(-580.187 -132.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M583.1,153.322l-7.041-20.577h-5.575l8.905,25.316h7.421l8.905-25.316h-5.575Z",
    transform: "translate(-510.781 -132.745)",
    fill: "#fff"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8db407da0a731087e1c06c16192b533.svg";
export { ForwardRef as ReactComponent };